const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '/api' 
  : 'http://localhost:3001/api';

export const createTanzaku = async (tanzakuData) => {
  const response = await fetch(`${API_BASE_URL}/tanzaku/create.php`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(tanzakuData)
  });
  
  if (!response.ok) {
    const errorText = await response.text();
    console.error("Create Tanzaku Error:", errorText);
    throw new Error('短冊の作成に失敗しました');
  }
  
  return response.json();
};

export const getTanzaku = async () => {
  const response = await fetch(`${API_BASE_URL}/tanzaku/list.php`);
  
  if (!response.ok) {
    const errorText = await response.text();
    console.error("Get Tanzaku Error:", errorText);
    throw new Error('短冊の取得に失敗しました');
  }
  
  return response.json();
};

export const likeTanzaku = async (id) => {
  const response = await fetch(`${API_BASE_URL}/tanzaku/like.php`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id })
  });
  
  if (!response.ok) {
    const errorText = await response.text();
    console.error("Like Tanzaku Error:", errorText);
    throw new Error('いいねに失敗しました');
  }
  
  return response.json();
};

export const deleteTanzaku = async (id) => {
  const response = await fetch(`${API_BASE_URL}/tanzaku/delete.php`, {
    method: 'POST', // PHP側がPOSTを期待しているため
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id })
  });

  if (!response.ok) {
    const errorText = await response.text();
    console.error("Delete Tanzaku Error:", errorText);
    throw new Error('短冊の削除に失敗しました');
  }

  return response.json();
};

export const updateTanzakuPosition = async (id, position) => {
  const response = await fetch(`${API_BASE_URL}/tanzaku/update-position.php`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id, x: position.x, y: position.y })
  });
  
  if (!response.ok) {
    const errorText = await response.text();
    console.error("Update Position Error:", errorText);
    throw new Error('位置の更新に失敗しました');
  }
  
  return response.json();
};